import { Tag } from '@design-system/components/tag/tag';
import { LibraryList, LibraryListProps } from './libraryList';
import { SearchInput } from '@design-system/components/searchinput';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { Folder } from '../../models/videos.domain';
import { Typography } from '@design-system/components/typography/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ContentFilters } from '@client/new/common/library/helpers';

type LibraryProps = LibraryListProps & {
  searchText: string;
  actionsDisabled: boolean;
  search: (value: string) => void;
  filterVideos: (type: ContentFilters) => void;
  activeVideoFilter: ContentFilters | null;
  currentFolder: (Folder & { count: string }) | null;
  backFromCurrentFolder: () => void;
  videoType: ContentFilters | null;
  smallerView: boolean;
};

export const Library = (p: LibraryProps) => {
  const { searchText, search } = p;
  return (
    <>
      {!p.currentFolder ? null : (
        <div>
          <div className="flex gap-4 items-center py-2 border-b-2">
            <FontAwesomeIcon
              icon={faArrowLeft}
              onClick={p.backFromCurrentFolder}
            />
            <div className="flex flex-col gap-1">
              <Typography variant="body" size="medium">
                {p.currentFolder.name}
              </Typography>
              <Typography variant="body" size="small" color="N-80">
                {p.currentFolder.count}
              </Typography>
            </div>
          </div>
        </div>
      )}
      <div className="flex gap-4">
        <Tag
          label="⚡️ Clip"
          onClick={() => p.filterVideos('short')}
          selected={p.activeVideoFilter === 'short'}
          disabled={!!p?.videoType}
        />
        <Tag
          label="📹 Video"
          onClick={() => p.filterVideos('long')}
          selected={p.activeVideoFilter === 'long'}
          disabled={!!p?.videoType}
        />
      </div>
      <SearchInput
        placeholder="Search by name"
        value={searchText}
        onChange={(e) => search(e.target.value)}
        onClear={() => search('')}
        inputWrapperClassName="bg-[#EEEEEE]"
      />
      <div className="max-h-[400px]">
        <LibraryList {...p} />
      </div>
    </>
  );
};
